import './animations.css';
import en from './components/translations/en.json';

export * from './img';
export * from './styling';
export * from './components';
export * from './dimensions';
export * from './styles';
export { default as Version } from './version';

export var translations = { en: en };